module.exports = __webpack_public_path__ + "static/lined-floater-e5441aa1a1531d1db4c4c468cd7164ef.png";